import * as constants from 'redux/constants/cart.constants';

export const updateCart = (
  itemId, quantity, descriptionId, wholesale, showNotification = true,
) => ({
  type: constants.CART_UPDATE_REQUESTED,
  itemId,
  quantity,
  descriptionId,
  wholesale,
  showNotification,
});

export const checkout = (type, formData, items, userId) => ({
  type,
  formData,
  items,
  userId,
});

export const submitCoupon = (coupon, email, total) => ({
  type: constants.CART_COUPON_REQUESTED,
  coupon,
  email,
  total,
});

export const deleteCoupon = () => ({
  type: constants.CART_COUPON_DELETE,
});

export const getProducts = (value) => ({
  type: constants.CART_GET_PRODUCTS_REQUESTED,
  value,
});

export const openCart   = () => ({ type: constants.CART_OPEN });
export const closeCart  = () => ({ type: constants.CART_CLOSE });
export const toggleCart = () => ({ type: constants.CART_TOGGLE });